module.exports = __webpack_public_path__ + "static/media/bubble-3-tablet.892f1696.svg";